'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A small collection of utilities to ensure environment variables
 */

var canUseDOM = exports.canUseDOM = !!(undefined && undefined.window && window.document && typeof window !== 'undefined' && window.document.createElement);
var canUseViewport = exports.canUseViewport = canUseDOM && !!window.screen;
var canUseEventListeners = exports.canUseEventListeners = canUseDOM && !!(window.addEventListener || window.attachEvent);
exports.default = {
  canUseDOM: canUseDOM,
  canUseViewport: canUseViewport,
  canUseEventListeners: canUseEventListeners
};